<template>
    <a-modal v-model="visible" title="修改密码" on-ok="handleSubmit">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleSubmit">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">

    <a-row class="item">
      <a-col :span="5"><label >账号名：</label></a-col>
      <a-col :span="17"><span>{{text.alias}}</span></a-col>
    </a-row>
    <a-row class="item">
      <a-col :span="5"><label >手机号：</label></a-col>
      <a-col :span="17"><span>{{text.account}}</span></a-col>
    </a-row>
        <a-form-item v-bind="formItemLayout" label="新密码" has-feedback>
          <a-input allowClear
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: '密码至少8位字符!',
                  },
                  { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '请输入合法字符，字母/数字至少包含2种'},
                  {
                    validator: validateToNextPassword,
                  },
                ],
              },
            ]"
            type="password"
          />
    </a-form-item>
    <a-form-item v-bind="formItemLayout" label="确认密码" has-feedback>
      <a-input allowClear
        v-decorator="[
          'confirm',
          {
            rules: [
              {
                required: true,
                message: '请再次输入密码!',
              },
              { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '请输入合法字符，字母/数字至少包含2种'},
              {
                validator: compareToFirstPassword,
              },
            ],
          },
        ]"
        type="password"
        @blur="handleConfirmBlur"
      />
    </a-form-item>
        </a-form>
    </a-modal>
</template>
<script>
export default {
  props:{
    mode:{
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      formItemLayout: "",
      loading: false,
      visible: false,
      formLayout: "horizontal",
      text:{},
      form: this.$form.createForm(this, { name: "coordinated" }),
    };
  },
  methods: {
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("两次密码不一致!");
      } else {
        callback();
      }
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let url = '';
          if (this.mode=='1') {
            url = '/manager/modifyRecord'
          } else if(this.mode=='2'){
             url = '/supplier/modifyRecord'
          }else if(this.mode=='3'){
             url = '/distributor/modifyRecord'
          }
          let {confirm,...params} = values;
          
          params.id = this.text.id;
          
          ///manager/modifyRecord
          this.$http.post(url,params).then(res=>{

            if (res.result) {
              this.$message.success('修改成功')
              this.handleCancel();
              this.$emit("getdata");
            }else{
              this.$message.warning(res.message)
            }
          })
        }
      });
    },
    showModal(text) {
      this.text = text;
      this.visible = true;
    },
    handleCancel(e) {
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.item {
    margin-bottom: 16px;
    .ant-col-5{
      text-align: right;
    }
    label{
      color: rgba(0, 0, 0, 0.85)!important;
    } 
}

    
</style>
